export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 8_03.c1179671.jpg";